import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedUiModule } from 'src/app/shared/shared-ui.module';
import { AridosEncuestaSatisfaccionComponent } from './encuesta-satisfaccion/encuesta-satisfaccion.component';
import { AridosModalFirmaPapelComponent } from './modal-firma-papel/modal-firma-papel.component';
import { AridosSurveySuccessModalComponent } from './survey-success-modal/survey-success-modal.component';

@NgModule({
  declarations: [
    AridosEncuestaSatisfaccionComponent,
    AridosModalFirmaPapelComponent,
    AridosSurveySuccessModalComponent,
  ],
  imports: [CommonModule, FormsModule, MatDialogModule, SharedUiModule],
  exports: [
    AridosEncuestaSatisfaccionComponent,
    AridosModalFirmaPapelComponent,
    AridosSurveySuccessModalComponent,
  ],
})
export class AridosFirmaDigitalModule {}
